module.exports = __webpack_public_path__ + "img/ordered-list.8e20a543.svg";